(function() { window.GUID_bcf3adbe_60c0_4ee3_8313_a9985f532a73 = { getGuid: function() { return "bcf3adbe-60c0-4ee3-8313-a9985f532a73"; } }; })();
//namespace CS.Views {
//    export class MasterPageOverlay implements IDisposable {
//        private $buttonBack: JQuery;
//        private $buttonRefresh: JQuery;
//        public $Overlay: JQuery;
//        private onAjaxStateChangeDelegate: any;
//        private refreshOnClose: boolean;
//        public static OverlayDisplayed: boolean;
//        public MasterPageRefreshNeeded: boolean;
//        public static DisposeAllInstances() {
//            let $instances = MasterPageOverlay.OverlayInstances();
//            if ($instances && $instances.length > 0) {
//                for (var i = 0; i < $instances.length; i++) {
//                    $instances[i].Dispose();
//                }
//            }
//        }
//        public static OverlayInstances(): Array<MasterPageOverlay> {
//            let $overlays: JQuery;
//            if (CS.DOM.$sectionMaster != null) {
//                $overlays = CS.DOM.$sectionMaster.find('.master-overlay');
//            }
//            let array: Array<MasterPageOverlay> = new Array<MasterPageOverlay>();
//            $.each($overlays, function () {
//                let $this = $(this);
//                array.push($this.data('instance'));
//            });
//            return array;
//        }
//        public static get LastInstance(): MasterPageOverlay {
//            let instances = this.OverlayInstances();
//            if (instances.length > 0) {
//                return instances[instances.length - 1];
//            }
//            return null;
//        }
//        public get RefreshUrl(): string {
//            return this.$Overlay.data('href');
//        }
//        public GetLastInstanceOfOtherTypeBefore(): MasterPageOverlay {
//            let instances = MasterPageOverlay.OverlayInstances();
//            let start = instances.indexOf(this);
//            if (instances.length > 0) {
//                for (var i = 0; i < instances.length; i++) {
//                    let instance = instances[i];
//                    if (instance && !this.IsSameGroupInstance(instance)) {
//                        return instance;
//                    }
//                }
//            }
//            return null;
//        }
//        constructor(response, headerValues: CS.Ajax.IAjaxHeader) {
//            let me = this;
//            CS.Views.MasterPageOverlay.OverlayDisplayed = true;
//            me.saveCurrentStates();
//            me.$Overlay = $(response);
//            let overlayId = me.$Overlay.attr('id');
//            me.$Overlay.css('opacity', 0);
//            me.$Overlay.data('instance', me);
//            //Ce IF  evite qun overlay puisse etre appelé et que la page loadé de depart etait elle aussi le meme contenu
//            if (me.testIfMasterPageOriginalEqualNewOverlay()) {
//                me.MasterPageRefreshNeeded = true;
//                return;
//            }
//            me.cleanLastInstances();
//            me.$Overlay.appendTo(CS.DOM.$sectionMaster);
//            me.$buttonBack = me.$Overlay.find('.button-back');
//            me.$buttonBack.offon('click.' + overlayId, function () {
//                me.Close();
//            });
//            me.$buttonRefresh = me.$Overlay.find('.button-refresh');
//            me.$buttonRefresh.offon('click.masteroverlay', function () {
//                me.Refresh();
//            });
//            requestAnimationFrame(function () {
//                CS.DOM.$win.scrollTop(0);
//                CS.DOM.Refreshed();
//                me.$Overlay.animate({ opacity: 1 }, 500, () => {
//                    const $topbar = me.$Overlay.find(".section-top");
//                    if ($topbar.length > 0) {
//                        const $innerSubTop = me.$Overlay.find(".section-inner-subtop");
//                        if ($innerSubTop.length > 0) {
//                            requestAnimationFrame(() => {
//                                const topbarHeight = $topbar.outerHeight() - 1;
//                                $innerSubTop.css({
//                                    top: `${topbarHeight}px`
//                                });
//                                me.$Overlay.find('.section-middle').css({ 'padding-top': `${topbarHeight}px` });
//                            });
//                        }
//                    }
//                });
//            });
//            CS.PopState.OnNavigation(headerValues.newUrl, false, () => {
//                me.Close();
//            });
//            me.onAjaxStateChangeDelegate = CS.Ajax.AjaxListener.OnAjaxStateChange((state, extra, url) => {
//                if (extra.isPost && state == Ajax.AjaxState.CallEnded) {
//                    if (!me.testIfPostUrlDontNeedRefreshOnClose(url)) {
//                        me.ActivateRefreshOnClose();
//                    }
//                }
//            });
//        }
//        private testIfPostUrlDontNeedRefreshOnClose(url: string) {
//            return url.indexOf('/wallsections/getsection') != 1 ||
//                url.indexOf('/mainsearch/updateuserfavorites') != -1;
//        }
//        private cleanLastInstances() {
//            let me = this;
//            let instances = CS.Views.MasterPageOverlay.OverlayInstances();
//            let disposeNextInstances = false;
//            for (var i = 0; i < instances.length; i++) {
//                let instance = instances[i];
//                let lastOverlayId = instance.$Overlay.attr('id');
//                if (me.$Overlay.find('style').length > 0) {
//                    me.$Overlay.find('style')[0].innerHTML += "#" + lastOverlayId + "{display:none;}";
//                }
//                if (disposeNextInstances) {
//                    instance.Dispose();
//                }
//                else if (this.IsSameGroupInstance(instance)) {
//                    if (CS.Views.MasterPageOverlay.LastInstance == instance) {
//                        this.refreshOnClose = instance.refreshOnClose;
//                    }
//                    instance.Dispose();
//                    disposeNextInstances = true;
//                }
//            }
//        }
//        private testIfMasterPageOriginalEqualNewOverlay() {
//            //Fut substitué par une methode dans ActionExecuted du CSAppController.cs
//            //Ainsi, ca evite un double call parce que cest pas fait en 2 étapes
//            return false;
//            //let bodyClasses = CS.DOM.$body[0].classList;
//            //var sameController = false;
//            //var sameAction = false;
//            //for (var i = 0; i < bodyClasses.length; i++) {
//            //    let bodyClass = bodyClasses[i];
//            //    if (bodyClass.indexOf("controller-") > -1) {
//            //        sameController = this.$Overlay.hasClass(bodyClass);
//            //    }
//            //    if (bodyClass.indexOf("action-") > -1) {
//            //        sameAction = this.$Overlay.hasClass(bodyClass);
//            //    }
//            //}
//            //return sameAction && sameController;
//        }
//        public Refresh() {
//            CS.Nav.Go(this.$Overlay.data('href'), null, Nav.Source.Refresh);
//        }
//        public Close() {
//            this.Dispose();
//            CS.DOM.$body.trigger('masterpageoverlayclose');
//            if (this.refreshOnClose) {
//                CS.Nav.Refresh();
//            }
//            else {
//                CS.Controls.LazyLoadHelper.Activate();
//            }
//        }
//        private saveCurrentStates() {
//            let lastScrollStates: Array<number> = CS.DOM.$win.data('lastscrollstates');
//            if (!lastScrollStates) {
//                lastScrollStates = new Array<number>();
//                CS.DOM.$win.data('lastscrollstates', lastScrollStates);
//            }
//            lastScrollStates.push(CS.DOM.$win.scrollTop());
//        }
//        private restoreLastWindowScroll() {
//            let lastScrollStates: Array<number> = CS.DOM.$win.data('lastscrollstates');
//            if (lastScrollStates && lastScrollStates.length > 0) {
//                let lastScroll = lastScrollStates.pop();
//                CS.DOM.$win.scrollTop(lastScroll);
//            }
//        }
//        Dispose() {
//            this.$buttonBack.off('click.masteroverlay');
//            CS.DOM.DisposeChilds(this.$Overlay);
//            this.$Overlay.remove();
//            this.restoreLastWindowScroll();
//            if (this.onAjaxStateChangeDelegate) {
//                CS.Ajax.AjaxListener.Remove(this.onAjaxStateChangeDelegate);
//            }
//            if (CS.Views.MasterPageOverlay.LastInstance == null) {
//                CS.Views.MasterPageOverlay.OverlayDisplayed = false;
//                CS.DOM.$sectionMiddle.css('opacity', 1);
//            }
//            CS.PopState.GoBackIfNotAlreadyDone();
//            CS.Ads.RefreshEzoicAds();
//        }
//        public IsSameGroupInstance(overlay: MasterPageOverlay) {
//            return this.$Overlay.data('overlaygroup') == overlay.$Overlay.data('overlaygroup');
//        }
//        public ActivateRefreshOnClose() {
//            if (this.refreshOnClose == true) {
//                return;
//            }
//            this.refreshOnClose = true;
//            let lastInstanceOfOtherType = this.GetLastInstanceOfOtherTypeBefore();
//            if (lastInstanceOfOtherType) {
//                lastInstanceOfOtherType.ActivateRefreshOnClose();
//            }
//        }
//        public static RemoveRemainingInstances() {
//            if (CS.Views && CS.Views.MasterPageOverlay && CS.Views.MasterPageOverlay.OverlayDisplayed) {
//                let instances = MasterPageOverlay.OverlayInstances();
//                for (var i = 0; i < instances.length; i++) {
//                    if (instances[i]) {
//                        instances[i].Dispose();
//                    }
//                }
//            }
//        }
//    }
//}

//# sourceMappingURL=masterpage.overlay.js.map
